module.exports = __webpack_public_path__ + "img/cronograma-full.bed59807.png";